var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNotifications = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "notifications_svg__a",
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h16v16H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#notifications_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2.668 12.665v-1.333h1.333V6.665c0-.922.278-1.741.834-2.458A3.845 3.845 0 0 1 7 2.799v-.467c0-.278.098-.514.292-.708a.964.964 0 0 1 .708-.292c.278 0 .514.097.709.292.194.194.291.43.291.708v.467a3.845 3.845 0 0 1 2.167 1.408c.556.717.833 1.536.833 2.458v4.667h1.334v1.333H2.668Zm5.333 2c-.366 0-.68-.13-.941-.391a1.284 1.284 0 0 1-.392-.942h2.667c0 .367-.13.68-.392.942a1.284 1.284 0 0 1-.942.391Z"
}))));
export default SvgNotifications;